<main>
    <form [formGroup]="form">
        <div>
            <p class="title mb-5">Indique em qual data você deseja abrir um exceção</p>
        </div>
        <div class="mt-5 w-full flex align-items-center" style="text-align: left;">
            <span class="p-float-label col-6 pl-0">
                <p-calendar styleClass="custom-calendar-input w-full" [showIcon]="true"></p-calendar>
                <label for="data">Data de inicio</label>
            </span>
            <div class="mr-4 col-6">
                <p-dropdown 
                    styleClass="w-full custom-dropdown"
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="unidade" 
                    [options]="['','Leme','Bota fogo','Rio de janeiro','Campinas']" 
                    placeholder="Unidade"
                    inputId="unidade"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-buildings custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                </p-dropdown>
            </div>
        </div>
        <div class="mt-5">
            <span class="p-float-label w-full">
                <input pInputText class="w-full" />
                <label for="data">Nome do Bloqueio</label>
            </span>
        </div>
        <div class="mt-5 chose-time p-2 pr-5 pl-5 pb-5">
            <div>
                <p>10:40 - 12-20</p>
            </div>
            <div>
                <p class="pb-0 mb-2">Horáro de inicio e fim :</p>
            </div>
            <div class="flex align-items-center">
                <div class="mr-4">
                    <p-dropdown 
                    styleClass="w-full custom-dropdown"
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="hora1" 
                    [options]="['10:40','12:00','13:00','14:00']" 
                    styleClass="w-10rem" 
                    inputId="hora"
                    >
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-clock custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                    </p-dropdown>
                </div>
                <div>
                    <p-dropdown 
                    styleClass="w-full custom-dropdown"
                    [ngModelOptions]="{standalone: true}" 
                    [(ngModel)]="hora2" 
                    [options]="['12:00','12:20','13:00','14:00']" 
                    styleClass="w-10rem" 
                    inputId="hora"
                    >
                    
                        <ng-template let-item pTemplate="selectedItem">
                            <i class="bi bi-clock custom-dropdown-icon mr-2 ml-1"></i>
                            {{item}}
                        </ng-template>
                        
                    </p-dropdown>
                </div>
                <div class="ml-5">
                    <span class="option-label-1 underline">Personalizado</span>
                </div>
            </div>
            <div class="mt-5">
                <p class="pb-0 mb-2">Quais serviços você oferece ? </p>
            </div>
            <div class="flex mt-4">
                <div class="mr-3">
                    <p-radioButton formControlName="servicos" value="1" label="Todos os serviços"></p-radioButton>
                </div>
                <div>
                    <p-radioButton formControlName="servicos" value="2" label="Apenas serviços especificos"></p-radioButton>
                </div>
            </div>  
            <div class="pt-3 mt-4">
                <span class="option-label-1 underline">Criar novo horário</span>
            </div>
        </div>
    </form>
    <div class="footer">
        <button (click)="cancelar()" pRipple pButton class="p-button-outlined p-button-secondary flex justify-content-center ">
            CANCELAR
        </button>
        <button (click)="salvar()" pRipple pButton class="flex justify-content-center">
            CRIAR EXCEÇÃO
        </button>
    </div>
</main>
